<div class="container-fluid p-3 reader-page">
  <!-- Top-Toolbar: Zurück, Titel, Suche, Position, Prev/Next, Original-Toggle -->
  <div class="bp-toolbar d-flex align-items-center gap-2 mb-3 flex-wrap">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="back()">
      <i class="bi bi-arrow-left"></i> Zurück
    </button>
    <h5 class="mb-0 me-2">
      <i class="bi bi-journal-text"></i> Bodenformenkatalog
    </h5>

    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openNamensmatrix()"
            title="Namensmatrix: Kürzel × Substrat als klickbare Kreuztabelle">
      <i class="bi bi-grid-3x3-gap"></i> Namensmatrix
    </button>

    <!-- Suchfeld nur im Listen-Modus; bei geöffnetem Steckbrief (currentId) ausblenden. -->
    @if (!currentId) {
      <div class="input-group input-group-sm reader-search">
        <span class="input-group-text"><i class="bi bi-search"></i></span>
        <input type="text" class="form-control"
               placeholder="HBF, Lokalname/Abk., Forstbetrieb …"
               title="Sucht in HBF-Abkürzung/Name, Klassifikation, Substratgruppe sowie Feinbodenform-Lokalnamen, deren Abkürzungen und Forstbetrieben"
               [(ngModel)]="searchTerm"
               (ngModelChange)="applySearch()">
        @if (searchTerm) {
          <button type="button" class="btn btn-outline-secondary"
                  (click)="searchTerm = ''; applySearch()"
                  title="Suche zurücksetzen">
            <i class="bi bi-x"></i>
          </button>
        }
      </div>
    }

    @if (currentId) {
      <!-- Kopfzeile des Steckbriefs (HBF-Abk./Name/Substratgruppe) hier nochmal:
           im Steckbrief scrollt sie weg, die Toolbar bleibt stehen. -->
      @if (currentHeading; as hbf) {
        <span class="reader-hbf d-flex align-items-center gap-1"
              [title]="hbf.abkuerzung + ' – ' + hbf.name">
          <span class="badge bg-light text-dark border">{{ hbf.abkuerzung }}</span>
          <strong class="text-truncate">{{ hbf.name }}</strong>
          @if (hbf.substratgruppe) {
            <span class="text-muted small" title="Substratgruppe der Hauptbodenform">
              ({{ hbf.substratgruppe }})
            </span>
          }
        </span>
      }
      <span class="text-muted small">{{ position }}</span>

      <span class="ms-auto d-flex align-items-center gap-2">
        @if (canEdit$ | async) {
          <button type="button" class="btn btn-outline-primary btn-sm"
                  (click)="editCurrent()"
                  title="Diesen Steckbrief im Editor bearbeiten">
            <i class="bi bi-pencil-square"></i> Bearbeiten
          </button>
        }
        <button type="button" class="btn btn-outline-secondary btn-sm"
                (click)="prev()" [disabled]="!hasPrev"
                title="Vorheriger Steckbrief (Pfeil links)">
          <i class="bi bi-chevron-left"></i>
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm"
                (click)="next()" [disabled]="!hasNext"
                title="Nächster Steckbrief (Pfeil rechts)">
          <i class="bi bi-chevron-right"></i>
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm"
                (click)="toggleOriginal()" [class.active]="showOriginal"
                title="Original-PDF-Seite zum Vergleich dazublenden">
          <i class="bi bi-file-image"></i>
          {{ showOriginal ? 'Original aus' : 'Original' }}
        </button>
      </span>
    } @else if (!loading && entries.length) {
      <select class="form-select form-select-sm reader-filter reader-filter-sg"
              [(ngModel)]="filterSubstratgruppe" (ngModelChange)="applySearch()"
              title="Nach Substratgruppe filtern" aria-label="Nach Substratgruppe filtern">
        <option value="">Substrat: alle</option>
        @for (s of substratgruppeOptions; track s) {
          <option [value]="s">{{ s }}</option>
        }
      </select>
      <select class="form-select form-select-sm reader-filter reader-filter-klass"
              [(ngModel)]="filterKlassifikation" (ngModelChange)="applySearch()"
              title="Nach Klassifikation filtern" aria-label="Nach Klassifikation filtern">
        <option value="">Klassifikation: alle</option>
        @for (k of klassifikationOptions; track k) {
          <option [value]="k">{{ k }}</option>
        }
      </select>
      <span class="text-muted small ms-auto">{{ filteredEntries.length }} Einträge</span>
    }
  </div>

  <div class="reader-content">
  @if (loading) {
    <div class="text-muted">Lade Katalog …</div>
  } @else if (!entries.length) {
    <div class="alert alert-info">
      Der Bodenformenkatalog ist noch nicht befüllt.
      Steckbriefe werden über die <a routerLink="/listenverwaltung">Listenverwaltung</a>
      (Liste „Hauptbodenformenkatalog (SEA Teil D)") aus D_Parser importiert.
    </div>
  } @else if (!currentId) {
    <!-- Übersichtsliste (Listen-Modus): sortierbare Tabelle wie in der
         Listenverwaltung, plus Klassifikation und Seitenzahl. Klick öffnet den
         Steckbrief. -->
    @if (!filteredEntries.length) {
      <div class="alert alert-warning">
        Kein Treffer für „{{ searchTerm }}".
      </div>
    } @else {
      <table class="table table-sm table-striped table-hover lv-katalog-table mb-0">
        <thead>
          <tr>
            <th class="sortable col-k-substr text-center" (click)="setSort('substratgruppe')">
              Substratgruppe <i class="bi {{ sortIcon('substratgruppe') }}"></i>
            </th>
            <th class="sortable col-k-klass" (click)="setSort('klassifikation')">
              Klassifikation <i class="bi {{ sortIcon('klassifikation') }}"></i>
            </th>
            <th class="sortable col-k-abk" (click)="setSort('abkuerzung')">
              HBF Abk. <i class="bi {{ sortIcon('abkuerzung') }}"></i>
            </th>
            <th class="sortable" (click)="setSort('name')">
              HBF Name <i class="bi {{ sortIcon('name') }}"></i>
            </th>
            <th class="sortable col-k-nfbf text-end" (click)="setSort('fbf')"
                title="Anzahl Feinbodenformen">
              Anzahl <i class="bi {{ sortIcon('fbf') }}"></i>
            </th>
            <th class="sortable col-k-seite text-end pe-3" (click)="setSort('seitenzahl')">
              Seitenzahl <i class="bi {{ sortIcon('seitenzahl') }}"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (e of filteredEntries; track e.id) {
            <tr class="lv-katalog-row" (click)="openEntry(e.id)"
                tabindex="0" (keydown.enter)="openEntry(e.id)"
                title="Steckbrief öffnen">
              <td class="text-center">{{ e.hauptbodenform.substratgruppe || '–' }}</td>
              <td>{{ e.klassifikation || '–' }}</td>
              <td><span class="badge bg-light text-dark border">{{ e.hauptbodenform.abkuerzung || '–' }}</span></td>
              <td>{{ e.hauptbodenform.name || '(ohne Name)' }}</td>
              <td class="text-end">{{ e.feinbodenformen.length || 0 }}</td>
              <td class="text-end pe-3">{{ e.seitenzahl || '–' }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  } @else if (!filteredIds.length) {
    <div class="alert alert-warning">
      Kein Treffer für „{{ searchTerm }}".
    </div>
  } @else if (!current) {
    <div class="alert alert-warning">
      Steckbrief nicht gefunden.
    </div>
  } @else {
    <div class="reader-layout" [class.with-original]="showOriginal">
      @if (showOriginal) {
        <div class="reader-original">
          <app-sea-original [pdf]="current.pdf" [page]="current.page">
          </app-sea-original>
        </div>
      }
      <div class="reader-preview">
        <app-bodensteckbrief-preview [entry]="current" [embedded]="true">
        </app-bodensteckbrief-preview>
      </div>
    </div>
  }
  </div>
</div>
